/* @flow */

import { useSelector } from 'react-redux';
import { getPortalUtilityLength } from '../selector/portalRegistrationSelector';

export default function usePortalRegistrationLength(portalKey: string): Object {
  return useSelector(getPortalUtilityLength(portalKey));
}
